import { auth } from '../../firebase/init';

const PROJECT_ID = 'asador-1293f';
const REGION = 'us-central1';
const FUNCTIONS_BASE_URL_OVERRIDE = String(process.env.VUE_APP_FUNCTIONS_BASE_URL || '').trim();
const USE_FUNCTIONS_EMULATOR = String(process.env.VUE_APP_USE_FUNCTIONS_EMULATOR || '').trim().toLowerCase() === 'true';

const getFunctionsBaseUrl = () => {
  if (FUNCTIONS_BASE_URL_OVERRIDE) {
    return FUNCTIONS_BASE_URL_OVERRIDE.replace(/\/$/, '');
  }

  if (USE_FUNCTIONS_EMULATOR) {
    return `http://127.0.0.1:5001/${PROJECT_ID}/${REGION}`;
  }

  return `https://${REGION}-${PROJECT_ID}.cloudfunctions.net`;
};

const parseResponseBody = async (response) => {
  const text = await response.text();
  if (!text) {
    return {};
  }

  try {
    return JSON.parse(text);
  } catch (error) {
    return { message: text };
  }
};

const request = async (endpoint, options = {}) => {
  const { method = 'POST', body, authRequired = false } = options;
  const headers = {
    'Content-Type': 'application/json'
  };
  const requestUrl = `${getFunctionsBaseUrl()}/${endpoint}`;

  if (authRequired) {
    const user = auth.currentUser;
    if (!user) {
      throw new Error('Debes iniciar sesión para continuar.');
    }

    const token = await user.getIdToken();
    headers.Authorization = `Bearer ${token}`;
  }

  let response;
  try {
    response = await fetch(requestUrl, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined
    });
  } catch (error) {
    const usingEmulator = requestUrl.includes('127.0.0.1:5001');
    const hint = usingEmulator
      ? 'No se pudo conectar al emulador de Cloud Functions en localhost:5001.'
      : 'No se pudo conectar al endpoint de Cloud Functions desplegado.';
    throw new Error(`${hint} Verifica si la función "${endpoint}" está desplegada y accesible.`);
  }

  const payload = await parseResponseBody(response);

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error(`La función "${endpoint}" no está disponible en el backend.`);
    }
    const error = new Error(payload?.message || payload?.error || 'Ocurrió un error inesperado.');
    error.status = response.status;
    error.endpoint = endpoint;
    throw error;
  }

  return payload;
};

export { request };
